module.exports = __webpack_public_path__ + "img/Voice-BG-img.001e0897.webp";